module.exports = __webpack_public_path__ + "img/ics_o_multiple_file.cff3bc20.svg";